import {
    Component,
    EventEmitter,
    Output,
    ViewChild,
    input,
    inject
} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {WinOlsTransactionModel} from "../../models/WinOlsTransaction-model";
import {SortDirectionValuesModel} from "../../models/SortDirectionValues-model";
import {WinOlsTransactionService} from "../../service/winols-transaction.service";
import {Router} from "@angular/router";


@Component({
    selector: 'app-win-ols-transaction-table',
    templateUrl: './win-ols-transaction-table.component.html',
    styleUrl: './win-ols-transaction-table.component.css'
})
export class WinOlsTransactionTableComponent {

    @ViewChild(MatSort) sort: MatSort;

    winOlsTransactions = input<WinOlsTransactionModel[]>([]);
    displayedTableHeaders = input<string[]>();
    displayedColumns = input<(keyof WinOlsTransactionModel)[]>();
    sortDirectionValues = input<SortDirectionValuesModel>();

    @Output() downloadOriginalFile = new EventEmitter();
    @Output() changeSortDirection = new EventEmitter();
    @Output() downloadCompletedFile = new EventEmitter();
    @Output() downloadFileFromTable = new EventEmitter();
    @Output() openSimilarPureOriginalId = new EventEmitter();

    winOlsTransactionService = inject(WinOlsTransactionService);
    router = inject(Router)


    isDownloadInProgress(id: number) {
        return this.winOlsTransactionService.isDownloadInProgress(id);
    }

    downloadFile (trace: string, id: number, route: string) {
        this.downloadFileFromTable.emit({trace, id, route});
    }
    changeMasterTableSortDirection(event: any) {
        this.changeSortDirection.emit(event);
    }
    openPureOriginalMatchingDetails (pureOriginalId: number) {
        this.winOlsTransactionService.openPureOriginalMatchingDetails(pureOriginalId);
    }


    navigateToSimilarPureOriginalId(similarPureOriginalId: string) {
        this.router.navigate(['/app/pure-originals/pure-original-details'], { queryParams: { pureOriginalId: similarPureOriginalId } });
    }

    formatDate(value: any, column: string): string {
        if (value == null || value === '') return '-';

        const dateColumns = ['date', 'dateUploaded', 'dateUpdated', 'dateExported', 'dateMatched', 'versionDateUploaded', 'dateuploaded'];
        if (dateColumns.includes(column)) {
            const parts = value.toString().split('-');
            if (parts.length < 6) return value;

            let year, month, day, hours, minutes, seconds;

            if (parseInt(parts[0], 10) > 12) {
                day = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10) - 1;
                year = parseInt(parts[2], 10);
            } else if (parseInt(parts[1], 10) > 12) {
                month = parseInt(parts[0], 10) - 1;
                day = parseInt(parts[1], 10);
                year = parseInt(parts[2], 10);
            } else {
                if (column === 'dateuploaded') {
                    month = parseInt(parts[0], 10) - 1;
                    day = parseInt(parts[1], 10);
                } else {
                    day = parseInt(parts[0], 10);
                    month = parseInt(parts[1], 10) - 1;
                }
                year = parseInt(parts[2], 10);
            }

            hours = parseInt(parts[3], 10);
            minutes = parseInt(parts[4], 10);
            seconds = parseInt(parts[5], 10);

            const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

            if (isNaN(utcDate.getTime())) return value;

            const localDay = utcDate.getDate().toString().padStart(2, '0');
            const localMonth = (utcDate.getMonth() + 1).toString().padStart(2, '0');
            const localYear = utcDate.getFullYear();
            const localHours = utcDate.getHours().toString().padStart(2, '0');
            const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
            const localSeconds = utcDate.getSeconds().toString().padStart(2, '0');

            return `${localDay}-${localMonth}-${localYear} ${localHours}:${localMinutes}:${localSeconds}`;
        }

        return value;
    }

}
